// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","suggestionText":"_1R06iat9XGQa","userOptions":"_3yoUihstMHPB","flag":"JvfjvsDmxZ1f"};